var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32989 7.69141H3.82989V7.19141V4.92203C3.82989 3.53057 4.25925 2.43256 4.97521 1.68573C5.68905 0.941113 6.73107 0.50009 8.04788 0.5C8.04802 0.5 8.04815 0.5 8.04829 0.5L10.5 0.504V3.37299L8.88047 3.37358C8.88041 3.37358 8.88035 3.37358 8.88029 3.37358C8.24681 3.3736 7.70669 3.49435 7.35787 3.89601C7.02426 4.28015 6.9789 4.80086 6.9789 5.26763V7.19141V7.69141H7.4789H10.3804L10.3793 10.7953H7.4789H6.9789V11.2953V19.5H3.82989V11.2953V10.7953H3.32989H0.86364V7.69141H3.32989ZM10.5991 3.37295H10.5989H10.5991Z",
    stroke: "#787676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9aa8fb7b8fee1a804115ad54ada83a5d.svg";
export { ForwardRef as ReactComponent };